export class Vesselslist {
    Id: number;

    VesselsName: string;

    VesselsImoNumber: string

    VesselsCode: string

    ShippingLineId: number;

    ShippingLineIds: number[];

    VessselsType: number;

    CallSign: string;

    MisiNumber: string;

    GRT: number;

    CEUCapacity: number;

    CbmCapacity: number;      
}
